<template>
  <div>
    <Modal :visible="visible" @cancel="handleCancel" :keyboard="false">
      <ApplyCoupon
        :visible="visible"
        :planData="planDetail"
        :stayDay="stayDay"
        :stayNights="stayNights"
        :stayRooms="stayRooms"
        :vacancyCalendar="vacancyCalendar"
        source="order_confirmation"
        @change="onChangeCouponPlan"
        @ok="handleOk"
        @getTotalCoupon="getTotalCoupon"
        @cancel="handleCancel"
      />
    </Modal>
  </div>
</template>

<script>
import { get, cloneDeep } from 'lodash'
import ApplyCoupon from '../ApplyCoupon'

export default {
  name: 'UseCouponPopup',
  components: {
    ApplyCoupon
  },
  props: ['visible'],
  data() {
    return {
      datetimeFormat: 'YYYY-MM-DD HH:mm:ss',
      planDetail: null,
      stayDay: null,
      stayNights: null,
      stayRooms: null,
      vacancyCalendar: null,
      couponObj: null
    }
  },
  mounted() {
    if (this.statePlanDetail) {
      this.planDetail = this.statePlanDetail
    }
    if (this.stateCustomerPlan) {
      this.stayDay = this.stateCustomerPlan.stayDay
      this.stayNights = this.stateCustomerPlan.stayNights
      this.stayRooms = this.stateCustomerPlan.stayRooms
      this.vacancyCalendar = this.stateCustomerPlan.vacancyCalendar
    }
  },
  computed: {
    statePlanDetail() {
      return cloneDeep(this.$store.getters.planDetail)
    },
    stateCustomerPlan() {
      return cloneDeep(this.$store.getters.customerPlan)
    },
    bsAppState() {
      return cloneDeep(this.$store.getters.bs_app)
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    }
  },
  methods: {
    onChangeCouponPlan() {
      // this.updatedCouponData = JSON.parse(JSON.stringify($event))
    },
    getTotalCoupon($event) {
      this.couponObj = $event
    },
    handleOk($event) {
      this.$emit('ok', $event)
      this.$emit('getTotalCoupon', this.couponObj)
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="css">
.coupon-popup-footer {
  @apply flex justify-end gap-x-2;
}
</style>
